module.exports = __webpack_public_path__ + "img/view.1ab4d525.svg";